module.exports = __webpack_public_path__ + "d16.no2.9a31b765.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d16.no2.jpg
// module id = BY7e
// module chunks = 0